import React from 'react';
import StatusBadge from '../common/StatusBadge';

const OrdersMobileView = ({ orders, onManualReviewDecision }) => {
    return (
        <div className="md:hidden space-y-4">
            {orders.map((order) => (
                <div key={order.id} className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex flex-col gap-3">
                    <div className="flex justify-between items-start">
                        <div>
                            <span className="text-xs font-mono text-indigo-600 bg-indigo-50 px-2 py-1 rounded">
                                {order.id}
                            </span>
                            <h4 className="font-bold text-slate-800 mt-1">{order.username}</h4>
                        </div>
                        <StatusBadge status={order.status} />
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-sm">
                        <div className="text-slate-500">
                            Сумма: <span className="text-slate-800 font-semibold">{order.amount} ₽</span>
                        </div>
                        <div className="text-slate-500">
                            Товар: <span className="text-slate-800">{order.productCell}</span>
                        </div>
                        <div className="text-slate-500 text-xs">
                            Тип: <span className="text-slate-700">{order.purchaseKindLabel}</span>
                        </div>
                    </div>
                    <div className="text-xs text-slate-400 border-t pt-2 mt-1">
                        Получатель: {order.recipient} <br />
                        Источник: {order.source} <br />
                        Тип: {order.type} <br />
                        {order.date}
                    </div>
                    {order.manualReviewStatus === 'pending' && (
                        <div className="flex gap-2 border-t pt-3">
                            <button
                                type="button"
                                onClick={() => onManualReviewDecision?.(order, 'accept')}
                                className="flex-1 px-3 py-2 bg-emerald-600 text-white rounded-lg text-xs"
                            >
                                Подтвердить
                            </button>
                            <button
                                type="button"
                                onClick={() => onManualReviewDecision?.(order, 'reject')}
                                className="flex-1 px-3 py-2 bg-rose-600 text-white rounded-lg text-xs"
                            >
                                Отклонить
                            </button>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default OrdersMobileView;